import {Controller} from 'stimulus'

export default class extends Controller {
  static targets = [
    'corporationId',
    'chart',
    'chartLoading',
    'retryContent',
    'daterange',
    'exportLink'
  ]

  controllerName() {
    return this.identifier.split('--')[1]
  }

  get path() {
    return this.data.get("path")
  }

  get daterange() {
    return this.targetDaterange || this.dataDaterange
  }

  get targetDaterange() {
    if (this.targets.has('daterange') && this.daterangeTarget.value) {
      return this.daterangeTarget.value.split(' to ')
    }
  }

  get dataDaterange() {
    return JSON.parse(this.data.get('defaultDaterange'))
  }

  get analyticParams() {
    let filterQuery = {
      'start_date': this.daterange[0],
      'end_date': this.daterange[1], 
      'chart_type': this.data.get('chartType') || 'line',
    }

    if ($('#pmc_select').length) {
      filterQuery["corporation_id"] = this.corporationIdTarget.value
    }

    if ($('#community-select').length) {
      filterQuery["community_id"] = $('#community-select').val()
    }

    return filterQuery
  }

  fireNativeEvent() {
    if ($('#pmc_select').length) {
      $('#pmc_select').on('select2:select', function () {
        let event = new Event('change', { bubbles: true }) // fire a native event
        this.dispatchEvent(event);
      });
    }
  }

  setParams() {
    return this.analyticParams
  }

  shouldDisplayChart() {
    return this.daterange
  }

  connect() {
    this.refreshExportLink()
    if (this.shouldDisplayChart()) {
      this.getChart(this.setParams())
    }
    this.fireNativeEvent()
  }

  refreshExportLink() {
    if (this.targets.has('exportLink')) {
      this.exportLinkTarget.href = this.csvUrl()
    }
  }

  csvUrl() {
    const path = this.path || this.controllerName()
    const params = { ...this.setParams(), format: 'csv' }
    return `/analytics/${path}?${$.param(params)}`
  }

  getChart(data = {}) {
    $.get({
      dataType: 'script',
      url: `/analytics/${this.path || this.controllerName()}`,
      data,
      success: () => {
        this.chartLoadingTarget.classList.add('d-none')
        this.refreshExportLink()
      }
    })
  }

  getCommunities() {
    $.get({
      dataType: 'script',
      url: "/analytics/get_communities",
      data: {
        corporation_id: this.corporationIdTarget.value
      }
    })
  }

  handleSubmit(e) {
    this.chartLoadingTarget.classList.remove('d-none')
    this.chartTarget.classList.add('d-none')
    this.getChart(this.setParams())
  }

  retryChart(e) {
    e.preventDefault()
    this.retryContentTarget.classList.add('d-none')
    this.chartLoadingTarget.classList.remove('d-none')
    this.getChart(this.setParams())
  }

}
